import { styled } from '@mui/material'

export const AlertList = styled('ul')(({ theme }) => ({
  margin: theme.spacing(1, 0),
  paddingLeft: theme.spacing(2.5),
}))
